function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_486",
  "data-name": "Rechteck 486",
  width: 59.81,
  height: 64.933,
  fill: "none",
  stroke: "#009fe3",
  strokeWidth: 2
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_1655",
  "data-name": "Gruppe 1655",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pfad_1324",
  "data-name": "Pfad 1324",
  d: "M58.663,61.89c0-10.166-7.256-17.08-17.6-20.417L29.983,53.342,18.8,41.407C8.354,44.707,1,51.734,1,61.89",
  transform: "translate(0.073 3.043)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Linie_35",
  "data-name": "Linie 35",
  y2: 8.548,
  transform: "translate(30.057 56.385)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_1325",
  "data-name": "Pfad 1325",
  d: "M44.346,24.229a2.376,2.376,0,0,0,1.031.292c.617,0,.946-.44.735-1.335-.333-1.447-.945-3.254-1.262-4.662L43.737,7.874c0-1.732-1.451-2.787-3.167-3.134-1.935-.384-5.627-1.356-8.308-2.085C31.96,1.712,30.682,1,29.148,1a3.181,3.181,0,0,0-3.106,1.63c-2.646.728-6.358,1.721-8.314,2.11-1.718.347-3.17,1.4-3.17,3.134L13.406,18.7c-.452,1.3-.794,2.935-1.222,4.476-.2.715.054,1.321.79,1.321a2.274,2.274,0,0,0,.976-.272c5.7-2.8,10.231-4.216,15.236-4.218C34.167,20.009,38.782,21.461,44.346,24.229Z",
  transform: "translate(0.891 0.073)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_1326",
  "data-name": "Pfad 1326",
  d: "M13.265,18.032A35,35,0,0,1,29,13.547c4.6,0,10.251,1.593,15.9,4.485",
  transform: "translate(0.975 0.995)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_1327",
  "data-name": "Pfad 1327",
  d: "M43.117,22.155a14.516,14.516,0,1,1-28.558.145",
  transform: "translate(1.054 1.628)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_1328",
  "data-name": "Pfad 1328",
  d: "M17.5,41.919s1.165-1.748,1.118-7.462",
  transform: "translate(1.286 2.532)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_1329",
  "data-name": "Pfad 1329",
  d: "M38.4,41.926s-1.164-1.855-1.118-7.566",
  transform: "translate(2.74 2.525)",
  fill: "none",
  stroke: "#009fe3",
  strokeLinejoin: "round",
  strokeWidth: 2
}));

function SvgPersona1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59.81,
    height: 64.933,
    viewBox: "0 0 59.81 64.933",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersona1);
export default __webpack_public_path__ + "static/media/persona1.b2ee5a7e.svg";
export { ForwardRef as ReactComponent };